import FJVerticalScroller from '../FJScroller/FJVerticalScroller';
import FJHorizontalVirtualizedList from '../FJVirtualizedList/FJHorizontalVirtualizedList';
import FJCategoryItemHeader from './FJCategoryItemHeader';
import classNames from 'classnames';
import FJMoreButton from '../FJMoreButton/FJMoreButton';
import styles from './FJPanelCategoryList.module.less';
import PropTypes from 'prop-types';
/**
 * @desc 通用面板分类列表
 * @param {} props
 * @returns
 */
const MORE_BUTTON_COUNT = 12;
const FJPanelCategoryList = props => {
    const {
        data,
        maxCount,
        isShowSeeAll = true,
        previewItemHeight = 92, // 每个分类下预览 item 的高度
        moreButtonHeight = 93, // 更多按钮的高度

        // 样式
        panelStyle,
        horizontalItemClassName,
        boxClass,
        scrollerClassName,
        arrowStyle,

        // 组件 渲染
        renderBeforeBox,
        renderAfterBox,
        renderItem,

        notShowMoreButton = false,

        // 事件
        onTotalScroll,
        onScrollStart,
        seeAll,

        categoryStyle,
    } = props;

    const onClickSeeAll = collection => {
        if (!seeAll) return;
        seeAll(collection);
    };

    const renderCategoryItem = collection => {
        const curList = collection?.list || [];
        return (
            <div className={classNames(styles.horizontal_list, horizontalItemClassName)} style={categoryStyle}>
                <FJHorizontalVirtualizedList
                    hasShadow={false}
                    scrollerStyle={{ width: '100%', height: previewItemHeight }}
                    innerClassName={styles.horizontal_scroller_inner}
                    list={curList}
                    arrowStyle={arrowStyle}
                    renderItem={item => {
                        return renderItem(item, collection);
                    }}
                >
                    {curList.length > MORE_BUTTON_COUNT && !notShowMoreButton ? (
                        <FJMoreButton
                            boxStyle={{
                                width: (4 / 9) * moreButtonHeight,
                                height: moreButtonHeight,
                            }}
                            onClick={() => onClickSeeAll(collection)}
                        />
                    ) : null}
                </FJHorizontalVirtualizedList>
            </div>
        );
    };

    const renderCategoryListItem = collection => {
        let collectionName = collection.category;
        return (
            <div key={collectionName}>
                <FJCategoryItemHeader
                    title={collectionName}
                    isShowSeeAll={isShowSeeAll}
                    seeAll={() => {
                        onClickSeeAll(collection);
                    }}
                />
                {renderCategoryItem(collection)}
            </div>
        );
    };

    /**
     * @desc
     * @returns
     */
    const renderCollectionList = () => {
        const endCount = maxCount || data.length;
        const list = data.slice(0, endCount);
        return list
            .filter(item => !!item)
            .map((collection, index) => {
                return renderCategoryListItem(collection, index);
            });
    };

    /**
     * @desc 分类列表前的dom 渲染
     */
    const renderBeforeView = () => {
        if (renderBeforeBox) return renderBeforeBox();
    };

    /**
     * @desc 分类列表后的dom 渲染
     */
    const renderAfterView = () => {
        if (renderAfterBox) return renderAfterBox();
    };

    let cn = classNames(styles.box, boxClass);
    return (
        <div className={cn} style={panelStyle}>
            <FJVerticalScroller
                onTotalScroll={onTotalScroll}
                onScrollStart={onScrollStart}
                className={classNames(styles.scroller_box, scrollerClassName)}
            >
                {renderBeforeView()}
                {renderCollectionList()}
                {renderAfterView()}
            </FJVerticalScroller>
        </div>
    );
};
FJPanelCategoryList.propTypes = {
    type: PropTypes.string,
    data: PropTypes.array,
    maxCount: PropTypes.number,
    isShowSeeAll: PropTypes.bool,
    previewItemHeight: PropTypes.number,
    moreButtonHeight: PropTypes.number,
    panelStyle: PropTypes.object,
    horizontalItemClassName: PropTypes.string,
    boxClass: PropTypes.string,
    scrollerClassName: PropTypes.string,
    arrowStyle: PropTypes.object,
    renderBeforeBox: PropTypes.func,
    renderAfterBox: PropTypes.func,
    renderItem: PropTypes.func,
    notShowMoreButton: PropTypes.bool,
    onTotalScroll: PropTypes.func,
    onScrollStart: PropTypes.func,
    seeAll: PropTypes.func,
    categoryStyle: PropTypes.object,
};
export default FJPanelCategoryList;
